/** @format */
import { type ReactNode } from 'react';
import { CustomDropDown } from 'src/components/CustomDropDown/CustomDropDown';
import { FilterIcon } from 'src/components/icons';

type SortSelectItem = {
  key: string;
  label: ReactNode;
  value?: string;
};

type SortSelectDropdownProps = {
  items?: SortSelectItem[];
  label?: ReactNode;
  onSelect?: (item: SortSelectItem) => void;
  placement?: 'bottom' | 'bottomRight' | 'bottomLeft' | 'top' | 'topRight' | 'topLeft';
  triggerClassName?: string;
  triggerLabelClassName?: string;
  triggerIcon?: ReactNode;
  menuClassName?: string;
  menuItemClassName?: string;
  itemClassName?: string;
  activeItemClassName?: string;
  selectedKey?: string;
  getItemValue?: (item: SortSelectItem) => string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  defaultValue?: string;
  onReset?: (defaultValue: unknown) => void;
  resetAriaLabel?: string;
};

export default function SortSelectDropdown({
  items = [],
  label,
  onSelect = () => {},
  placement = 'bottomRight',
  triggerClassName = 'search-page__filter-trigger search-page__filter-trigger--sort',
  triggerLabelClassName = 'search-page__filter-trigger-label',
  triggerIcon = <FilterIcon />,
  menuClassName = 'custom-dropdown__menu',
  menuItemClassName = 'custom-dropdown__menu-item',
  itemClassName = '',
  activeItemClassName = '',
  selectedKey = undefined,
  getItemValue = item => item.key,
  open,
  onOpenChange,
  defaultValue,
  onReset,
  resetAriaLabel
}: SortSelectDropdownProps) {
  return (
    <CustomDropDown
      placement={placement}
      open={open}
      onOpenChange={onOpenChange}
      value={selectedKey}
      defaultValue={defaultValue}
      onReset={onReset}
      resetAriaLabel={resetAriaLabel}
      trigger={
      <button type="button" className={triggerClassName} aria-expanded={open}>
        <span className={triggerLabelClassName}>{label}</span>
        {triggerIcon}
      </button>
      }>
      <ul className={menuClassName} role="menu">
        {items.map(item => {
          const value = getItemValue(item);
          const isActive = selectedKey !== undefined && value === selectedKey;
          const btnClassName = `${itemClassName}${isActive && activeItemClassName ? ` ${activeItemClassName}` : ''}`.trim();
          return (
            <li className={menuItemClassName} role="none" key={item.key}>
              <button type="button" role="menuitem" className={btnClassName} onClick={() => onSelect(item)}>
                {item.label}
              </button>
            </li>
          );
        })}
      </ul>
    </CustomDropDown>
  );
}
